module.exports = __webpack_public_path__ + "static/img/info02@2x.212a8464.png";